import CustomNotFound from "@/modules/notFound";
import Ranking from "@/modules/ranking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/ranking")({
  component: Ranking,
  notFoundComponent: CustomNotFound,
});
